import type { EventCategory } from './base';

export const OnboardingEvents = {
  ONBOARDING_SECTION_INTERACTED: {
    categories: ['all'] as EventCategory[],
    properties: {
      status: 'started' as 'started' | 'ongoing' | 'completed' | 'skipped',
      section: 'string' as string,
    },
  },
  ONBOARDING_STEP_DONE: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      section: 'string' as string,
      numberOfStep: 1 as number,
      totalStepCount: 3 as number,
      buttonClicked: 'next' as 'next' | 'previous' | 'finish',
    },
  },
} as const;
